
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/programmes/[courseSlug]/[goalUID]",
      function () {
        return require("private-next-pages/programmes/[courseSlug]/[goalUID].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/programmes/[courseSlug]/[goalUID]"])
      });
    }
  